import { filter } from 'ramda';
import { fakeApiHelper } from '~~utils/CommonUtils';
import ApiService from '~~commonAPIs/ApiService';

const debugStatus = {
  searchSameNamePlayers: false,
  getPlayersInSeasonTeam: false,
  createPlayerInSeasonTeamByOrganizer: false,
  updatePlayerInSeasonTeamByOrganizer: false,
  deletePlayerInSeasonTeamByOrganizer: false,
  getTeamRecentPlayers: false,
  getPlayersClaimStatus: false,
  updatePermission: false,
  updateProfile: false,
};

const Player = {
  searchSameNamePlayers: ({ name, leagueUniqids = [], exact = false }) => {
    if (debugStatus.searchSameNamePlayers) {
      return fakeApiHelper(200, 'success', {
        data: [
          {
            avatar_path: '',
            avatar_url: '',
            experiences: [
              {
                number: '16',
                season: '2020 北區高中棒球聯會夏季聯賽',
                season_uniqid: 'nH8l-2020-Sc',
                season_year: 2020,
                team: '成功高中',
              },
              {
                number: '16',
                season: '2021 北區高中棒球聯會冬季聯賽',
                season_uniqid: 'nH8l-2021-23',
                season_year: 2021,
                team: '成功高中',
              },
            ],
            name: '海賊王',
            uniqid: 'PjS0',
          },
        ],
        error: false,
        message: 'Get players successfully',
      });
    }

    return new Promise((resolve, reject) => {
      return ApiService.get(
        `/api/players?query=${name}${leagueUniqids.map((uniqid) => `&leagues=${uniqid}`).join('')}${
          exact ? '&exact=true' : ''
        }`,
      )
        .then((data) => {
          const players = data.data;
          resolve({
            ...data,
            data: filter((p) => p.name === name, players),
          });
        })
        .catch((e) => reject(e));
    });
  },

  getPlayersInSeasonTeam: ({ seasonUniqid, seasonTeamUniqid }) => {
    if (debugStatus.getPlayersInSeasonTeam) {
      return fakeApiHelper(200, 'success', {
        data: [
          {
            avatar_url: '',
            joined_game: true,
            name: 'AAA',
            number: '15',
          },
          {
            avatar_url: '',
            joined_game: true,
            name: 'BBB',
            number: '16',
          },
          {
            avatar_url: '',
            joined_game: true,
            name: 'CCC',
            number: '13',
          },
        ],
        error: false,
        message: 'Get season team players successfully',
      });
    }

    return ApiService.get(`/api/seasons/${seasonUniqid}/teams/${seasonTeamUniqid}/players`);
  },

  createPlayerInSeasonTeamByOrganizer: ({ leagueUniqid, seasonUniqid, seasonTeamUniqid, data }) => {
    return ApiService.post(`/api/leagues/${leagueUniqid}/seasons/${seasonUniqid}/teams/${seasonTeamUniqid}/players`, {
      data,
    });
  },

  updatePlayerInSeasonTeamByOrganizer: ({ leagueUniqid, seasonUniqid, seasonTeamUniqid, playerNumber, data }) => {
    return ApiService.put(
      `/api/leagues/${leagueUniqid}/seasons/${seasonUniqid}/teams/${seasonTeamUniqid}/players/` +
        `${encodeURIComponent(playerNumber)}`,
      { data },
    );
  },

  deletePlayerInSeasonTeamByOrganizer: ({ leagueUniqid, seasonUniqid, seasonTeamUniqid, playerNumber }) => {
    return ApiService.delete(
      `/api/leagues/${leagueUniqid}/seasons/${seasonUniqid}/teams/${seasonTeamUniqid}/players/` +
        `${encodeURIComponent(playerNumber)}`,
    );
  },

  getTeamRecentPlayers: ({ teamUniqid }) => {
    return ApiService.get(`/api/teams/${teamUniqid}/recent_players`);
  },

  getPlayersClaimStatus: ({ playerUniqids }) => {
    return ApiService.get(`/api/permission/player/batch/adopted?uniqid=${playerUniqids.join('&uniqid=')}`);
  },

  updatePermission: ({ userUniqid, playerUniqid, authority }) => {
    return ApiService.put(`/api/users/${userUniqid}/permission/player/${playerUniqid}`, { data: { authority } });
  },

  updateProfile: ({ playerUniqid, data }) => {
    return ApiService.put(`/api/players/${playerUniqid}/profile`, { data });
  },

  getPlayer: ({ playerUniqid }) => {
    return ApiService.get(`/api/players/${playerUniqid}`);
  },

  getPlayers: ({ playerUniqids }) => {
    return ApiService.get(`/api/players?uniqids=${playerUniqids.join('&uniqids=')}`);
  },
};

export default Player;
